import React from "react";

export const PageTitle: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <h3
      style={{
        margin: "3rem 1rem 3rem",
        textTransform: "uppercase",
        fontWeight: "bold",
      }}
    >
      {children}
    </h3>
  );
};
